module.exports = __webpack_public_path__ + "img/MultiSelect.9fe13700.svg";